'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$ItemUpdated(item) {
  this.KV = null;
  this.KV = item;
}
export { $c_Lpresto_crud$ItemUpdated as $c_Lpresto_crud$ItemUpdated };
$p = $c_Lpresto_crud$ItemUpdated.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$ItemUpdated;
/** @constructor */
function $h_Lpresto_crud$ItemUpdated() {
}
export { $h_Lpresto_crud$ItemUpdated as $h_Lpresto_crud$ItemUpdated };
$h_Lpresto_crud$ItemUpdated.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_crud$ItemUpdated) && $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.KV, x$0.KV)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ItemUpdated";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KV;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$ItemUpdated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jc)));
}
export { $isArrayOf_Lpresto_crud$ItemUpdated as $isArrayOf_Lpresto_crud$ItemUpdated };
var $d_Lpresto_crud$ItemUpdated = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$ItemUpdated, "presto.crud$ItemUpdated", ({
  jc: 1,
  bw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$ItemUpdated as $d_Lpresto_crud$ItemUpdated };
//# sourceMappingURL=presto.crud$-Item-Updated.js.map
